import rawSites from "./jlptOverseasSites.generated.json";

export const JLPT_OVERSEAS_DIRECTORY_URL = "https://www.jlpt.jp/e/application/overseas_list.html";
export const JLPT_OVERSEAS_MOBILE_DIRECTORY_URL = "https://www.jlpt.jp/sp/e/application/overseas_list.html";

export type JlptSessionAvailability = {
    available: boolean;
    cancelled: boolean;
    note: string | null;
};

export type JlptOverseasSite = {
    id: string;
    region: string;
    country: string;
    city: string | null;
    hostInstitution: string | null;
    july: JlptSessionAvailability;
    december: JlptSessionAvailability;
    website: string | null;
    telephone: string | null;
    email: string | null;
    fax: string | null;
    countryNotice: string | null;
    suspensionStatus: "temporarily-suspended" | "suspended-for-2026" | "pending" | null;
    lastVerified: string;
    officialSourceUrl: string;
};

// Generated from the official directory during maintenance, never fetched by
// the client. See scripts/extract-jlpt-overseas-sites.mjs for the reviewable
// importer and source metadata on every record.
export const jlptOverseasSites = rawSites as JlptOverseasSite[];

export const jlpt2026Sessions = {
    july: { label: "July 2026", date: "Sunday, July 5, 2026" },
    december: { label: "December 2026", date: "Sunday, December 6, 2026" },
} as const;
